export default "__VITE_ASSET__ed8e4abb__"